/* eslint-disable @typescript-eslint/no-explicit-any */
import { SortDirectionEnum } from '@gripp/shared-logic';
import { AssignmentListGrid } from '@gripp/shared-ui';
import { ColumnDef } from '@tanstack/react-table';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMediaColumns } from './useMediaColumns';

const FIND_ASSIGNABLE_MEDIA = `
  query FindAssignableMedia($filter: FindAssignableMediaFilter!, $page: PageRequest, $orderBy: OrderByInput) {
    media {
      findAssignableMedia(filter: $filter, page: $page, orderBy: $orderBy) {
        count
        limit
        offset
        items {
          id
          name
          categories {
            name
          }
        }
      }
    }
  }
`;

export type AddonMediaAssignmentListProps = {
  workspaceId: string;
  addonId: string;
  maxHeight?: number;
  keyword?: string;
  mediaAssignments: string[];
  onMediaAssignmentsChange: (assignments: string[]) => void;
};

export const AddonMediaAssignmentList = ({
  workspaceId,
  addonId,
  maxHeight,
  keyword,
  mediaAssignments,
  onMediaAssignmentsChange,
}: AddonMediaAssignmentListProps) => {
  const { t } = useTranslation();
  const [filter, setFilter] = useState<any>(() => {
    if (workspaceId) {
      return {
        keyword,
        addonId,
        workspaceId,
        // removed assignments from filter to prevent refetch on each toggle
      };
    }
    return undefined;
  });
  const columns = useMediaColumns() as ColumnDef<any, any>[];

  useEffect(() => {
    setFilter({
      keyword,
      addonId,
      workspaceId,
    });
  }, [keyword, addonId, workspaceId]);

  if (!filter) return null;

  return (
    <AssignmentListGrid
      modelName="media"
      query={FIND_ASSIGNABLE_MEDIA}
      dataPrefix="media.findAssignableMedia"
      columns={columns}
      filter={filter}
      assignments={mediaAssignments}
      onAssignmentsChange={onMediaAssignmentsChange}
      maxHeight={maxHeight}
      textEmpty={t('addOn.files.textEmpty')}
      orderBy={{ field: 'name', order: SortDirectionEnum.Asc }}
    />
  );
};
